export default __webpack_public_path__ + "static/dspm-icon-42913dc66132a59665b83771ac2c46f7.svg";